import { styled, Typography } from '@mui/material';
import { chromeYellow, spaceCadet, ultraMarine } from '../../../../../../../../utils/colors';

const Tag = styled(Typography)({
  textTransform: 'uppercase',
  borderRadius: 4,
  paddingTop: 1,
  paddingBottom: 1,
  paddingLeft: 4,
  paddingRight: 4,
  fontSize: 10,
  textDecoration: 'none',
  fontWeight: 700,
  padding: '2px 6px',
  '&.admin': {
    backgroundColor: spaceCadet[100],
    color: spaceCadet[400],
  },
  '&.user': {
    backgroundColor: ultraMarine[100],
    color: ultraMarine[400],
  },
  '&.expert-user': {
    backgroundColor: '#FFEBE8',
    color: '#cF7A6D',
  },
  '&.owner': {
    backgroundColor: chromeYellow[100],
    color: chromeYellow[500],
  },
});

export default Tag;
